import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteUser } from 'api/users.service';
import { AxiosError } from 'axios';
import { useToast } from 'hooks/ui';

export const useUserDeleteQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isPending, mutate } = useMutation({
    mutationFn: (emails: string[]) => deleteUser(emails),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      toast.success('User(s) have been deleted successfully');
    },
    onError: (error: AxiosError) => {
      toast.error(error.message);
    },
  });

  return { isLoading: isPending, mutate };
};
